import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Routes } from 'src/routes';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';
import { Box, Divider } from '@mui/material';
import ReceiptsFilters from './Controls';
import ReceiptsAbout from './About';
import ResultsTable from './Results/ResultsTable';
import { RootState } from 'src/store';
import {
  getReceiptsViewIsWithReceiptsData,
  getReceiptsViewIsWithReceiptsIntegration,
} from '../../store/receiptsViewSlice';
import EmptyView from './EmptyView';

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

const ReceiptsContent: FC<Props> = ({ isWithIntegration, isWithData }) => {
  const Content = useMemo(() => {
    if (isWithIntegration && isWithData) {
      return (
        <>
          <ReceiptsFilters />
          <Divider
            orientation="horizontal"
            flexItem
            variant="fullWidth"
            sx={{ mt: 1.5 }}
          />
          {/* <Grid container columnSpacing={2} rowSpacing={1.25} pb={10}>
        <Grid xs="auto">
          <Shortcuts shortcuts={shortcuts} />
        </Grid>
      </Grid> */}
          <ResultsTable />
        </>
      );
    }
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        <ReceiptsAbout />
        {isWithData ? <ResultsTable /> : <EmptyView />}
      </Box>
    );
  }, [isWithIntegration, isWithData]);

  return (
    <Box display="flex" flexDirection="column">
      {Content}
    </Box>
  );
};

const mapStateToProps = (state: RootState) => ({
  isWithIntegration: getReceiptsViewIsWithReceiptsIntegration(state),
  isWithData: getReceiptsViewIsWithReceiptsData(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goTo: (path: Routes) => dispatch(routingOnRouteRequest({ path })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptsContent);
